import {assetTypeToGroup} from "../../ducks/assets-duck.js";

const initialState = {
    companyValue: 0,
    privateValue: 0,
    totalValue: 0,
}

export const aggregateAssetsDistro = assets => {
    return assets.reduce((acc, cur) => {
        const rate = cur.currentRate || 0
        const groupKey = assetTypeToGroup(cur.asset_type)
        if(!acc.groups[groupKey]){
            acc.groups[groupKey] = { ...initialState, groupKey }
        }
        const companyValue = cur.amount_company * rate
        const privateValue = cur.amount_private * rate
        const totalValue = cur.value
        return {
            companyValue: acc.companyValue + companyValue,
            privateValue: acc.privateValue + privateValue,
            totalValue: acc.totalValue + totalValue,
            groups: {
                ...acc.groups,
                [groupKey]: {
                    ...acc.groups[groupKey],
                    companyValue: acc.groups[groupKey].companyValue + companyValue,
                    privateValue: acc.groups[groupKey].privateValue + privateValue,
                    totalValue: acc.groups[groupKey].totalValue + totalValue,
                }
            }
        }
    }, {
        ...initialState,
        groups: {}
    })
}